import { AlertTriangle } from 'lucide-react'

// Shown when the logged-in user's email does not match a people row, so no
// manager can be resolved server-side and all action buttons are disabled.
export function ManagerBanner() {
  return (
    <div className="flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <span>
        Your login is not linked to a Fleetly manager record, so you cannot record interview decisions.
        Contact an administrator to link your account.
      </span>
    </div>
  )
}
